import { WorkOrder, WorkOrdersByTechnician } from "../models/workOrderTypes";
import {
  UNASSIGNED_COLUMN_IDENTITY,
  type UnassignedSortOrder,
} from "./unassignedSort.types";

export function getSortedUnassignedWorkOrders(
  column: WorkOrdersByTechnician,
  sortOrder: UnassignedSortOrder,
): WorkOrder[] {
  if (column.identity !== UNASSIGNED_COLUMN_IDENTITY || sortOrder === "position") {
    return column.workOrders;
  }

  return [...column.workOrders].sort((a, b) => {
    const dateA = new Date(a.createdDate).getTime();
    const dateB = new Date(b.createdDate).getTime();

    if (Number.isNaN(dateA) || Number.isNaN(dateB)) {
      return 0;
    }

    return sortOrder === "dateAsc" ? dateA - dateB : dateB - dateA;
  });
}

export function getColumnWorkOrdersForDrag(
  column: WorkOrdersByTechnician,
  sortOrder: UnassignedSortOrder,
): WorkOrder[] {
  return getSortedUnassignedWorkOrders(column, sortOrder);
}
